@import 'apps/webcomponents/src/assets/fonts.scss';

:host {
  --datepicker-range-hover: var(--chart-100-pressed);
  --datepicker-cell-hovered: var(--chart-050-hover);
  --datepicker-cell-hovered-text: var(--main-titles-inputs-600);
  --datepicker-cell-pressed: var(--chart-100-pressed);
  --datepicker-cell-focused-border: var(--blue-layout-500-focus);
  --datepicker-cell-selected: var(--blue-layout-402-primary-background);
  --datepicker-cell-selected-text: var(--white-layout-300-primary);
  --datepicker-cell-disabled-text: var(--grey-layout-200-disabled);
  --datepicker-font-family: var(--font-family-secondary);
}

:host {
  display: block;
  font-family: var(--datepicker-font-family);
  font-size: var(--body-size);
}

.calendar-container {
  overflow: hidden;
}

.table {
  display: table;
  border-collapse: collapse;
  table-layout: fixed;
  font-family: var(--datepicker-font-family);
}

.th {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--chart-300-icon-buttons);
  padding: 7.14286% 0;
  margin: 0;
  width: 14.2857%;
  font-size: var(--body-size-medium);
}

.tr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: calc(4 * var(--spacer));
  text-transform: uppercase;
}

.td {
  flex: 1;
  height: calc(3 * var(--spacer));
}

.header {
  margin-bottom: var(--spacer);
  display: flex;
  align-items: center;

  .header-title {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-size: var(--body-size);
    font-weight: bold;
    color: var(--main-titles-inputs-600);

    &--month,
    &--year {
      margin-right: var(--spacer);
    }

    &--month {
      &::first-letter {
        text-transform: uppercase;
      }
    }
  }
}

.tbody {
  transition: all 0ms;
  transform: translateX(0);
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-row-gap: 2px;
  grid-column-gap: 12px;
}

.withTransition {
  transition: all 100ms;
}

.moveToLeft {
  opacity: 0;
  transform: translateX(-274px);
}

.moveToRight {
  opacity: 0;
  transform: translateX(274px);
}

.withTransition td,
.moveToLeft td,
.moveToRight td {
  border: none;
}

.year-container {
  position: relative;
  display: flex;
  align-items: center;
}

gz-datepicker-calendar-cell[hovered] {
  background: var(--blue-layout-103-background);
  position: relative;
}

gz-datepicker-calendar-cell[hovered][selected] {
  background: transparent;
}

gz-datepicker-calendar-cell:before {
  transition: background 0.3s ease;
}

gz-datepicker-calendar-cell[hovered]:before {
  content: '';
  width: calc(50% - 4px);
  height: 100%;
  position: absolute;
  z-index: -1;
  left: calc(-50% + 4px);
  background: var(--blue-layout-103-background);
}

gz-datepicker-calendar-cell[selected] {
  position: relative;
}

gz-datepicker-calendar-cell[hovered] + gz-datepicker-calendar-cell[enddate]:before {
  content: '';
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  left: calc(-50% + 4px);
  background: var(--blue-layout-103-background);
}

gz-datepicker-calendar-cell[startdate] + gz-datepicker-calendar-cell[hovered]:before {
  left: -80%;
  width: calc(100% - 6.5px);
}

gz-datepicker-calendar-cell[startdate][selected] + gz-datepicker-calendar-cell[enddate][selected]:before {
  content: '';
  width: 120%;
  height: 100%;
  position: absolute;
  z-index: -1;
  left: -80%;
  background: var(--datepicker-range-hover);
}

gz-datepicker-calendar-cell[enddate] {
  position: relative;
}

gz-datepicker-calendar-cell.td.enabled:first-of-type::before {
  width: 0;
}

.calendar-nav-button {
  height: 24px;
  &.prev {
    margin-right: var(--spacer);
  }
  &.next {
    margin-left: var(--spacer);
  }
}
